var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\" id=\"plus\"><path d=\"M22 9v13H9v6h13v13h6V28h13v-6H28V9h-6z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol